import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import JuniorLandingPage from "../Components/JuniorLandingPage";
import '../Styles/JuniorLandingPage.scss';
import {Helmet} from "react-helmet";

function JuniorHome() {
   return (
      <div>
         <Helmet>
            <title>Junior Camps - Camp Connect</title>
         </Helmet>
         <div className="juniorNavbar">
            <Navbar />
         </div>
         <JuniorLandingPage />
         <Footer />
      </div>
   )
}
export default JuniorHome;
